/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

import { format, parseISO } from 'date-fns';

/**
 * https://github.com/freearhey/vue2-filters/blob/master/src/other/pluralize.js
 *
 * 'item' => 'items'
 *
 * @params
 *  an array of strings corresponding to
 *  the single, double, triple ... forms of the word to
 *  be pluralized. When the number to be pluralized
 *  exceeds the length of the args, it will use the last
 *  entry in the array.
 *
 *  e.g. ['single', 'double', 'triple', 'multiple']
 *
 * Usage example:
 * {{item.count | pluralize('item')}} returns: 0 items, 1 item, 2 items...
 * {{item.count | pluralize('its', 'their)}} returns: 0 their, 1 its, 2 their...
 */

export const pluralize = function(value) {
  var args = Array.from(arguments).slice(1);
  return args.length > 1 ? args[(value % 10) - 1] || args[args.length - 1] : args[0] + (value === 1 ? '' : 's');
};

export const formatDate = function(date: string, dateFormat = 'M/d/yyyy h:mm a') {
  return format(parseISO(date), dateFormat);
};

export const formatFloat = function(float: string) {
  return parseFloat(float).toFixed(1);
};

/**
 * @param url string that you wish to turn into url
 * taken from https://stackoverflow.com/a/11300985/11027300
 * www.test.com => http://www.test.com
 * https://test.com => https://test.com
 * some string => http://somestring
 */

export const makeIntoUrl = function(url: string) {
  let newUrl = window.decodeURIComponent(url);
  newUrl = newUrl.trim().replace(/\s/g, '');

  if (/^(:\/\/)/.test(newUrl)) {
    return `http${newUrl}`;
  }
  if (!/^(f|ht)tps?:\/\//i.test(newUrl)) {
    return `http://${newUrl}`;
  }

  return newUrl;
};
